<!--==================================
=            TRANSACTIONS            =
===================================-->

<template>
	<div>
		<v-row>
			<base-header>
				<div slot="page-header">Transactions</div>
			</base-header>
		</v-row>
		<v-row>


			<v-col cols="12" sm="12" md="6">
				<base-card>
					<div slot="card-header">Sell Transactions</div>
					<div slot="card-body">
						<v-textarea class="pa-2 ma-2" label="SELL" dark auto-grow outlined rows="1" row-height="15">
						</v-textarea>
						<v-alert color="red" dark class="pa-2 ma-2 rounded-lg" icon="mdi-vuetify" border="left"
								 prominent>
							$ 2.454.134,00
						</v-alert>
						<v-alert color="green" dark class="pa-2 ma-2 rounded-lg" icon="mdi-vuetify" border="left"
								 prominent>
							$ 234,00
						</v-alert>

					</div>
				</base-card>
			</v-col>
			<v-col cols="12" sm="12" md="6">
				<base-card>
					<div slot="card-header">Buy Transactions</div>
					<div slot="card-body">
						<v-textarea class="pa-2 ma-2" label="BUY" dark auto-grow outlined rows="1" row-height="15">
						</v-textarea>
						<v-alert color="green" dark class="pa-2 ma-2 rounded-lg" icon="mdi-vuetify" border="left"
								 prominent>
							$ 2.454.134,00
						</v-alert>
						<v-alert color="green rounded-lg" dark class="pa-2 ma-2" icon="mdi-vuetify" border="left"
								 prominent>
							$ 2.454.134,00
						</v-alert>

					</div>
				</base-card>
			</v-col>

			<v-col cols="12" sm="12" md="12">
				<base-card>
					<div slot="card-header">Sell Transactions</div>
					<div slot="card-body">


						<card-table-tab></card-table-tab>
					</div>
				</base-card>
			</v-col>

		</v-row>


	</div>

</template>
<script>
	import BaseCard from "../../components/Base/BaseCard.vue";
	import BaseHeader from '../../components/Base/BaseHeader'
	import CardTableTab from '../../components/Cards/CardTableTab'
	export default {
		components: {
			BaseCard,
			BaseHeader,
			CardTableTab
		},
		data() {
			return {
				singleSelect: false,
				selected: [],
				headers: [{
						text: 'COIN',
						align: 'start',
						sortable: false,
						value: 'name',
					},
					{
						text: 'PRICE ($)',
						value: 'price'
					},
					{
						text: 'PROFIT ($)',
						value: 'profit'
					},
					{
						text: 'LOSS ($)',
						value: 'loss'
					},
					{
						text: 'VOLUME (%)',
						value: 'volume'
					},
					{
						text: 'TOTAL (%)',
						value: 'total'
					},
				],
				desserts: [{
						name: 'BTC',
						price: 159,
						profit: 6.0,
						loss: 24,
						volume: 4.0,
						total: '1%',
					},
					{
						name: 'ETH',
						price: 237,
						profit: 9.0,
						loss: 37,
						volume: 4.3,
						total: '1%',
					},
					{
						name: 'ZIL',
						price: 262,
						profit: 16.0,
						loss: 23,
						volume: 6.0,
						total: '7%',
					},
					{
						name: 'OMG',
						price: 305,
						profit: 3.7,
						loss: 67,
						volume: 4.3,
						total: '8%',
					},
					{
						name: 'KEY',
						price: 356,
						profit: 16.0,
						loss: 49,
						volume: 3.9,
						total: '16%',
					},
					{
						name: 'BAT',
						price: 375,
						profit: 0.0,
						loss: 94,
						volume: 0.0,
						total: '0%',
					},
					{
						name: 'BNB',
						price: 392,
						profit: 0.2,
						loss: 98,
						volume: 0,
						total: '2%',
					},
					{
						name: 'SOL',
						price: 408,
						profit: 3.2,
						loss: 87,
						volume: 6.5,
						total: '45%',
					},
					{
						name: 'CAKE',
						price: 452,
						profit: 25.0,
						loss: 51,
						volume: 4.9,
						total: '22%',
					},

				],
			}
		},

	}
</script>

<!--====  End of TRANSACTIONS  ====-->